import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import withApiError, {
  ERROR_TYPE_REPORTING,
} from 'layers/errorHandling/apiError'
import { selectors as reportsSelectors } from 'store/reportsManager'
import SchoolSummary from './component'
import { selectSchoolSummaryReportTableData } from './selectors'

export const SchoolSummaryContainer = ({
  administratorsCount,
  gradesWithClasses,
  gradesWithNoClasses,
  entry,
  hasClassesWithCompletedLessonLastPeriod,
  isFetchingSchool,
  k8ReportUnitSection,
  lastUpdatedAt,
  navigationHandler,
  numClassesWithCompletedLessonLastPeriod,
  period,
  reportTableData,
  schoolEmptyDisplay,
  selectedSite,
  siteName,
  teachersCount,
  totalClassesCount,
}) => {
  const handleSelectGrade = (navigationFunction, gradeName) => {
    navigationFunction({
      gradeName,
      siteId: selectedSite,
    })
  }

  return (
    <SchoolSummary
      administratorsCount={administratorsCount}
      entry={entry}
      gradesWithClasses={gradesWithClasses}
      gradesWithNoClasses={gradesWithNoClasses}
      handleSelectGrade={handleSelectGrade}
      hasClassesWithCompletedLessonLastPeriod={
        hasClassesWithCompletedLessonLastPeriod
      }
      isFetchingSchool={isFetchingSchool}
      k8ReportUnitSection={k8ReportUnitSection}
      lastUpdatedAt={lastUpdatedAt}
      navigationHandler={navigationHandler}
      numClassesWithCompletedLessonLastPeriod={
        numClassesWithCompletedLessonLastPeriod
      }
      period={period}
      reportTableData={reportTableData}
      schoolEmptyDisplay={schoolEmptyDisplay}
      selectedSite={selectedSite}
      siteName={siteName}
      teachersCount={teachersCount}
      totalClassesCount={totalClassesCount}
    />
  )
}

export const mapStateToProps = (state, ownProps) => {
  const { reportsManager } = state
  const { isFetchingSchool, selectedSite } = reportsManager || {}
  const { k8ReportUnitSection } = ownProps
  const reportTableData = selectSchoolSummaryReportTableData(
    state,
    k8ReportUnitSection,
  )
  const schoolSummaryReport = reportsSelectors.selectSchoolSummaryReport(state)
  const {
    administratorsCount,
    gradesWithClasses,
    gradesWithNoClasses,
    hasClassesWithCompletedLessonLastPeriod,
    lastUpdatedAt,
    numClassesWithCompletedLessonLastPeriod,
    period,
    siteName,
    teachersCount,
    totalClassesCount,
  } = schoolSummaryReport || {}

  return {
    administratorsCount,
    gradesWithClasses,
    gradesWithNoClasses,
    hasClassesWithCompletedLessonLastPeriod,
    isFetchingSchool,
    numClassesWithCompletedLessonLastPeriod,
    period,
    lastUpdatedAt,
    reportTableData,
    selectedSite,
    siteName,
    teachersCount,
    totalClassesCount,
  }
}

SchoolSummaryContainer.propTypes = {
  administratorsCount: PropTypes.number,
  entry: PropTypes.object,
  gradesWithClasses: PropTypes.array,
  gradesWithNoClasses: PropTypes.array,
  hasClassesWithCompletedLessonLastPeriod: PropTypes.bool,
  isFetchingSchool: PropTypes.bool,
  k8ReportUnitSection: PropTypes.string,
  lastUpdatedAt: PropTypes.string,
  navigationHandler: PropTypes.func,
  numClassesWithCompletedLessonLastPeriod: PropTypes.number,
  period: PropTypes.number,
  reportTableData: PropTypes.object,
  schoolEmptyDisplay: PropTypes.object,
  selectedSite: PropTypes.number,
  siteName: PropTypes.string,
  summaryReportExists: PropTypes.bool,
  summaryReportIsFetching: PropTypes.bool,
  teachersCount: PropTypes.number,
  totalClassesCount: PropTypes.number,
}

export default connect(mapStateToProps)(
  withApiError(SchoolSummaryContainer, [ERROR_TYPE_REPORTING]),
)
